export default function callWithMapped(func, propName) {
  return function(arr) {
    func(arr?.map(item => item[propName]) ?? []);
  };
}
